// utils/jwt.js
export const getJwtExpiry = (token) => {
  try {
    if (!token) return null;

    const base64Payload = token.split(".")[1];
    if (!base64Payload) return null;

    const payload = JSON.parse(
      atob(base64Payload.replace(/-/g, "+").replace(/_/g, "/"))
    );

    return payload.exp ? payload.exp * 1000 : null;
  } catch {
    return null;
  }
};